import { render, staticRenderFns } from "./CopyrightFormDetailsEscalated.vue?vue&type=template&id=79c35d71&scoped=true&"
import script from "./CopyrightFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFormDetailsEscalated.vue?vue&type=style&index=0&id=79c35d71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c35d71",
  null
  
)

export default component.exports